import { DatetimeModule } from 'src/app/pipe/datetime/datetime.module'
import { TranslateModule } from '@ngx-translate/core'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TemperatureModule } from 'src/app/pipe/temperature/temperature.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
	declarations: [MenuComponent],
	exports: [MenuComponent],
	imports: [
		CommonModule,
		IonicModule,
		FlexLayoutModule,
		RouterModule,
		TemperatureModule,
		TranslateModule,
		DatetimeModule
	]
})
export class MenuModule { }
